import { Cookies } from 'react-cookie';

import { MiceToTrapAmountChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const getMiceToTrapAmountChartData = async (
  slug: string,
  period: string,
  trapType: TrapType,
  start_date: string,
  end_date: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/analitycs/traps_to_mice_cought/${slug}/${period}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trapType,
      start_date,
      end_date,
    },
  });
  return data.data as MiceToTrapAmountChartData[];
};
